import "./styles.css"
import axios from '../../../../../services/axios'
import { useEffect, useState } from "react";
import { Card } from "../../../../Card/Index";
import { useEditOnboarding } from "../../../../../hooks/useEditOnboarding";

export function ListEvaluators() {
    const [listEvaluators, setListEvaluators] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const {
        setIdSelected,
        setDefaultValue,
        setOptionForm
    } = useEditOnboarding();

    useEffect(() => {
        setDefaultValue(undefined)
        setIdSelected(0)

        axios.get("/users/user/evaluator")
            .then(({ data: evaluators }) => {
                if (!Array.isArray(evaluators) || evaluators.length === 0) {
                    setListEvaluators([]);
                    return;
                }

                return Promise.all([
                    axios.get("/areas"),
                    axios.get("/micro-areas")
                ]).then(([{ data: areas }, { data: microAreas }]) => {
                const nextAreaMap = new Map<number, any>(
                    areas.map((area: any) => [Number(area?.id), area])
                );
                const microAreaMap = new Map<number, any>(
                    microAreas.map((microArea: any) => [Number(microArea?.id), microArea])
                );
                setListEvaluators(evaluators.map((el: any) => {
                    const microArea = microAreaMap.get(Number(el.micro_area_ids?.[0]));
                    const areaId = el.area_ids?.[0] ?? microArea?.area_id ?? microArea?.area?.id;

                    return {
                        ...el,
                        area: nextAreaMap.get(Number(areaId))
                    };
                }))
                });
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoading(false))
    }, []);

    const activeEvaluators = listEvaluators.filter((evaluator) => evaluator.status === "ACTIVE");

    if (isLoading) return null;

    if (activeEvaluators.length === 0) {
        return (
            <div className="evaluators-empty-state">
                <span>Nenhum avaliador cadastrado.</span>
            </div>
        );
    }

    return (<>
        <div className="grid__evaluators">
            {activeEvaluators.map((card) => (
                <Card
                    type={"micro-areas"}
                    initials={`${card?.area?.farm?.initials}-${card?.area?.initials}`}
                    name={card?.area?.manager_user?.name}
                    profile={"Capataz"}
                    onClick={() => {
                        setIdSelected(card.id)
                        setDefaultValue(card)
                        setOptionForm("create-evaluator")
                    }}
                    key={card.id}
                />
            ))}
        </div>
    </>)
}
